import {
  SCHOOL_CLIENT_LIST,
  ACCOUNT_VERIFICATION,
  FORGOT_PASSWORD,
  LOGIN,
  RESET_PASSWORD,
  My_CASELOAD,
  My_ACHIEVEMENTS,
  CASELOAD_TASK,
  PROFILE,
  PROFILE_SLUG,
  TASK_ONBOARD,
  SUPPORT_STAFF,
  TASK_PLANS_LIST,
  DOWNLOAD_CENTER,
  CHANGE_PASSWORD,
  CLASSROOM_REPORTS,
} from "config/paths";

import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import ActivateAccount from "./AuthPages/ActivateAccount/Index";
import MyCaseload from "./SideTabPages/Reports";
import MyAchievements from "./SideTabPages/myAchievements";
import CaseLoadTasks from "pages/SideTabPages/Reports/task";
import ProfileInformation from "./SideTabPages/Profile/[slug]";
import Profile from "./SideTabPages/Profile";
import TaskOnboard from "./Onboard";
import UserInformation from "components/shared/ProfileV2/UserInformation";
import Home from "./Home";
import SupportStaff from "./SupportStaff";
import TasksPlansList from "./SupportStaff/TasksPlans";
import DownloadCenter from "./DownloadCenter";
import ChangePassword from "components/shared/ProfileV2/ChangePassword";
import ClassroomReports from "./ClassroomReports";


export const routes = [
  { path: LOGIN, component: <Login /> },
  { path: FORGOT_PASSWORD, component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: RESET_PASSWORD, component: <ResetPassword /> },
  { path: ACCOUNT_VERIFICATION, component: <ActivateAccount /> },
];

export const privateRoutes = [
  { path: "/home", component: <Home /> },
  { path: SUPPORT_STAFF, component: <SupportStaff /> },
  { path: TASK_PLANS_LIST, component: <TasksPlansList /> },
  { path: My_CASELOAD, component: <MyCaseload /> },
  { path: CASELOAD_TASK, component: <CaseLoadTasks /> },
  { path: TASK_PLANS_LIST, component: <TasksPlansList /> },
  { path: CLASSROOM_REPORTS, component: <ClassroomReports /> },
  { path: DOWNLOAD_CENTER, component: <DownloadCenter /> },
  {
    path: PROFILE,
    component: <Profile />
  },
  {
    path: CHANGE_PASSWORD,
    component: <ChangePassword />
  },
  {
    path: PROFILE_SLUG,
    component: <ProfileInformation />
  },
  // { path: TASK_ONBOARD, component: <TaskOnboard /> },
];
